import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const OutletContext = createContext(null);
const KEY = "spbu_active_outlet";

export const OutletProvider = ({ children }) => {
  const { user } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [active, setActive] = useState(localStorage.getItem(KEY) || "default");

  const load = async () => {
    const r = await api.get("/outlets");
    setOutlets(r.data);
    if (!r.data.find((o) => o.code === active) && r.data[0]) {
      setActive(r.data[0].code);
      localStorage.setItem(KEY, r.data[0].code);
    }
  };

  useEffect(() => {
    if (user) load();
    // eslint-disable-next-line
  }, [user]);

  const switchOutlet = (code) => {
    setActive(code);
    localStorage.setItem(KEY, code);
    window.location.reload();
  };

  return (
    <OutletContext.Provider value={{ outlets, active, switchOutlet, reload: load }}>
      {children}
    </OutletContext.Provider>
  );
};

export const useOutlet = () => useContext(OutletContext) || { outlets: [], active: "default" };
